import { useHistory } from "react-router-dom"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import Applications from "../applications"

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { showEnvAuditNavigation } from "../../../store/actions";

const initialServices = [
  { name: "Drafted ToRs", key: "draftedToRCount", count: 0 },
  { name: "New Applications", key: "submittedEnvironmentCount", count: 0 },
  { name: "DM Pending", key: "pendingEnvironmentCount", count: 0 },
  {
    name: "Drafted EA Certificate",
    key: "draftedEACertificateCount",
    count: 0,
  },
  { name: "Approved Certificate", key: "approvedEnvironmentCount", count: 0 },
  { name: "All Applications", key: "all_applications", count: 0 },
]

import EnvAuditService from "services/applications/envAudit/EnvAuditService"
const user = JSON.parse(localStorage.getItem("authUser"))

const appService = new EnvAuditService(user)

const EnvAuditHeadDashboard = (props) => {
  const history = useHistory()
  const [mounted, setmounted] = useState(false)
  const [applications, setapplications] = useState()
  const [serviceName, setserviceName] = useState("")
  const [services, setServices] = useState(initialServices)
  const filter = new URLSearchParams(location.search).get("filter")

  const [hodSubmittedApps, sethodSubmittedApps] = useState(false)
  const [viewOnly, setviewOnly] = useState(false)
  const [assignStaff, setassignStaff] =  useState(false)

  
  

  useEffect(() => {
    if (props.showEnvAuditNav !== "SHOW_ENV_AUDIT_NAVIGATION") {
      props.showEnvAuditNavigation("SHOW_ENV_AUDIT_NAVIGATION")
    }
  }, [mounted])

  useEffect(() => {
    // fetchStatistics()
    setServiceDetails()

  }, [filter])

  const setServiceDetails = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const service_key = queryParams.get("filter");

    const serviceName = initialServices.find(service => service.key === service_key)["name"]
    
    setserviceName(serviceName)

    fetchData(serviceName)
  }

  const fetchData = (serviceName, page=1) => {
    setserviceName(serviceName)
    if (serviceName == "Request for ToRs") {
      getToRs(page)
    } else if (serviceName === "Drafted ToRs") {
      getDraftedToRs(page)
    } else if (serviceName === "New Applications") {
      setviewOnly(true)
      sethodSubmittedApps()
      setassignStaff(true)
      getNewApplications(page)
    } else if (serviceName === "DM Pending") {
      setviewOnly(false)
      sethodSubmittedApps(false)
      setassignStaff(false)
      getDMPendingApplications(page)
    } else if (serviceName === "Waiting EA Report") {
      getWaitingEAReport(page)
    } else if (serviceName === "Report for Review") {
      getReportForReview(page)
    } else if (serviceName === "Drafted EA Certificate") {
      getDraftedEACertificate(page)
    } else if (serviceName === "Approved Certificate") {
      getAllApprovedApplications(page)
    } else if (serviceName === "All Applications") {
      getAllApplications()
    }
  }

  const getNewApplications = (page) => {
    appService.getSubmittedApplications(page).then(response => {
      if (response.status) {
        setapplications(response.data)
        setmounted(true)
      }
    })
  }

  const getDMPendingApplications = (page) => {
    appService.getOfficerReviewedApplications(page).then(response => {
      // console.log(response.data)
      if (response.status) {
        setapplications(response.data)
        setmounted(true)
      }
    })
  }

  const getDraftedToRs = (page) => {
    appService.getDMDraftedApplications(page).then(response => {
      if (response.status) {
        setapplications(response.data)
        setmounted(true)
      }
    })
  }

  const getDraftedEACertificate = (page) => {
    appService.getDMDraftedEACertificate(page).then(response => {
      if (response.status) {
        setapplications(response.data)
        setmounted(true)
      }
    })
  }

  const getAllApprovedApplications = (page) => {
    // Endpoint to do this to be developed
    // getDMApprovedApplications
    appService.getDMApprovedApplications(page).then(response => {
      if (response.status) {
        setapplications(response.data)
        setmounted(true)
      }
    })
    // console.log("PASS")
  }

  const getAllApplications = () => {
    appService.getAllApplications().then(response => {
      if (response.status) {
        setapplications(response.data)
        setmounted(true)
      }
    })
  }
  
  const paginate = page => {
   fetchData(serviceName, page)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Environmental Audit Menu | REMA</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={12}>
                <h6 className="page-title">{serviceName}</h6>
              </Col>
            </Row>
          </div>

          {mounted ? (
            <Row>
              <Applications
                viewOnly={viewOnly}
                hodSubmittedApps={hodSubmittedApps}
                assignStaff={assignStaff}
                data={applications}
                user={user}
                  paginate={paginate}
              />
            </Row>
          ) : null}
        </Container>
      </div>
    </React.Fragment>
  )
}

EnvAuditHeadDashboard.propTypes = {
  showEnvAuditNavigation: PropTypes.func,
};

const mapStateToProps = (state) => ({
  showEnvAuditNav: state.Layout.show_env_audit_navigation,
});

export default withRouter(
  connect(mapStateToProps, { showEnvAuditNavigation })(EnvAuditHeadDashboard)
);
